module.exports = function() {
  return new Worker(__webpack_public_path__ + "943fb0ea22b7cef281c8.worker.js");
};